(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
      this.initStickyLinkDisabling();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    initStickyLinkDisabling() {
      // デスクトップメニューの無効化処理
      const disabledLinks = document.querySelectorAll('.sticky-disabled-link');
      
      console.log('デスクトップ無効化対象のリンク数:', disabledLinks.length);
      
      disabledLinks.forEach(link => {
        console.log('デスクトップ無効化対象リンク:', link.dataset.linkTitle);
        
        // クリックイベントを最優先で処理
        link.addEventListener('click', (e) => {
          // スティッキーヘッダーが表示されている時のみ無効化
          const isSticky = this.header.classList.contains('shopify-section-header-sticky');
          console.log('スティッキー状態:', isSticky, 'リンク:', link.dataset.linkTitle);
          
          if (isSticky) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
            console.log('デスクトップリンクの遷移を無効化しました:', link.dataset.linkTitle);
            return false;
          }
        }, true); // キャプチャフェーズで実行
      });

      // モバイルメニューの無効化処理
      const mobileDisabledLinks = document.querySelectorAll('.mobile-disabled-link');
      
      console.log('モバイル無効化対象のリンク数:', mobileDisabledLinks.length);
      
      mobileDisabledLinks.forEach(link => {
        console.log('モバイル無効化対象リンク:', link.dataset.linkTitle, 'タグ:', link.tagName);
        
        // aタグの場合のみクリックを無効化
        if (link.tagName.toLowerCase() === 'a') {
          link.addEventListener('click', (e) => {
            const isMobile = window.innerWidth < 990;
            console.log('モバイル状態:', isMobile, 'aタグリンク:', link.dataset.linkTitle);
            
            if (isMobile) {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              
              console.log('モバイルaタグリンクの遷移を無効化しました:', link.dataset.linkTitle);
              return false;
            }
          }, true);
        } 
        // spanタグ（summary内）の場合は子リスト展開を許可
        else if (link.tagName.toLowerCase() === 'span') {
          console.log('子リスト展開可能な項目（span）:', link.dataset.linkTitle);
          
          // spanタグ自体にはイベントリスナーを追加しない（details/summaryの動作を妨げないため）
          // ただし、サブメニュー内のリンクは無効化する
          const parentDetails = link.closest('details');
          if (parentDetails) {
            // サブメニュー内のtopbarのリンクを無効化
            const topbarLink = parentDetails.querySelector('.menu-drawer__topbar a.mobile-disabled-link');
            if (topbarLink) {
              topbarLink.addEventListener('click', (e) => {
                const isMobile = window.innerWidth < 990;
                if (isMobile) {
                  e.preventDefault();
                  e.stopPropagation();
                  e.stopImmediatePropagation();
                  console.log('サブメニュー内のリンクを無効化:', topbarLink.dataset.linkTitle);
                  return false;
                }
              }, true);
            }
          }
        }
      });
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 100);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      
      // スティッキーメニューの表示
      const stickyNav = document.querySelector('.sticky-only-nav');
      if (stickyNav) {
        stickyNav.classList.remove('shopify-section-header-hidden');
      }
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      
      // スティッキーメニューの非表示
      const stickyNav = document.querySelector('.sticky-only-nav');
      if (stickyNav) {
        stickyNav.classList.add('shopify-section-header-hidden');
      }
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  // デバッグ用：設定値を確認
  document.addEventListener('DOMContentLoaded', function() {
    const disabledLinksSettings = '{{ disabled_sticky_links | escape }}';
    console.log('無効化設定:', disabledLinksSettings);
    
    if (disabledLinksSettings) {
      const disabledArray = disabledLinksSettings.split(',').map(item => item.trim());
      console.log('無効化対象配列:', disabledArray);
    }
    
    // 実際に無効化クラスが付いているリンクを確認
    setTimeout(() => {
      const disabledLinks = document.querySelectorAll('.sticky-disabled-link');
      console.log('デスクトップ無効化クラスが付いているリンク:', disabledLinks.length);
      disabledLinks.forEach(link => {
        console.log('- デスクトップ:', link.dataset.linkTitle, link);
      });

      const mobileDisabledLinks = document.querySelectorAll('.mobile-disabled-link');
      console.log('モバイル無効化クラスが付いているリンク:', mobileDisabledLinks.length);
      mobileDisabledLinks.forEach(link => {
        console.log('- モバイル:', link.dataset.linkTitle, link);
      });
    }, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_bk"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 100);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
